
import { authHeader, handleResponse } from '../_helpers';
import { BehaviorSubject } from 'rxjs';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';


console.log('calling user.service script')

const currentUserSubject = new BehaviorSubject();
let authReady = null;

authReady = loadUserInfo();



export const userService = {
    loadUserInfo,
    completeProfile,
    logout,
    getFavourites,
    addFavourite,
    removeFavourite,
    removeAccount,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
    currentUserSubject: currentUserSubject,
    get ready() { return authReady || Promise.resolve() }
};

// favourites are keyed by the authenticated account on the backend
// (/users/me/...), so they work for facebook, google and apple logins
function getFavourites() {
    const header = authHeader()
    header['Content-Type'] = 'application/json'
    return fetch('/endpoint/users/me/favourites', {
        method: 'GET',
        headers: header
    }).then(res => res.json())
}

// add/remove return the updated user; push it into the subject so the
// favourites state stays in sync across components without a re-login
function addFavourite(propertyId) {
    const header = authHeader()
    header['Content-Type'] = 'application/json'
    return fetch('/endpoint/users/me/favourites', {
        method: 'POST',
        headers: header,
        body: JSON.stringify({ property_id: propertyId })
    })
        .then(res => res.json())
        .then(data => {
            if (data.result) currentUserSubject.next({ ...currentUserSubject.value, favourites: data.result.favourites })
            return data
        })
}

function removeFavourite(propertyId) {
    const header = authHeader()
    header['Content-Type'] = 'application/json'
    return fetch(`/endpoint/users/me/favourites/${propertyId}`, {
        method: 'DELETE',
        headers: header
    })
        .then(res => res.json())
        .then(data => {
            if (data.result) currentUserSubject.next({ ...currentUserSubject.value, favourites: data.result.favourites })
            return data
        })
}

function removeAccount() {
    const header = authHeader()
    header['Content-Type'] = 'application/json'
    return fetch('/endpoint/users/', {
        method: 'DELETE',
        headers: header
    }).then(res => res.json())
}



async function completeProfile(data) {
    let header = authHeader()
    header['Content-Type'] = 'application/json'
    const requestOptions = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(data),
        redirect: 'follow'
    };

    return fetch('/endpoint/auth/complete-profile', requestOptions)
        .then(handleResponse)
        .then(function (responseJson) {
            // the backend returns a fresh token with status=active — the cookie
            // is set server-side, but we need to reload the user from it
            loadUserInfo()
            return responseJson
        })
        .catch(function (err) {
            // if the token expired during the flow, force re-login
            console.log('complete-profile failed:', err)
            logout()
            throw err
        })

}

function loadUserInfo() {
    let token = Cookies.get('token')
    if (token) {
        console.log('setting user in userservice')
        var decoded = jwt_decode(token);

        // Legacy tokens embedded the full user doc as decoded.user (string or object)
        let user = decoded.user
        if (user && typeof user === 'string') {
            try { user = JSON.parse(user) } catch(e) { user = null }
        }

        if (user && user._id) {
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);
            validateSession()
            return Promise.resolve()
        } else {
            // New tokens only have { userId, email, role } — fetch full profile
            const header = authHeader()
            header['Content-Type'] = 'application/json'
            return fetch('/endpoint/users/me', { headers: header })
                .then(res => {
                    if (res.status === 401 || res.status === 403) { logout(); return null }
                    return res.json()
                })
                .then(data => {
                    if (data && data.result) {
                        localStorage.setItem('currentUser', JSON.stringify(data.result));
                        currentUserSubject.next(data.result);
                    }
                })
                .catch(() => {})
        }
    }
    else {
        currentUserSubject.next(null)
        return Promise.resolve()
    }
}

// the token cookie expires after 1h — probe the backend so a stale session
// logs out cleanly instead of every action silently failing
function validateSession() {
    try {
        fetch('/endpoint/users/validate', {
            method: 'GET',
            headers: authHeader()
        })
            .then(res => {
                if (res.status === 401 || res.status === 403) logout()
            })
            .catch(() => { /* network hiccup — keep the session */ })
    } catch (e) {
        console.log(e)
    }
}


function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    Cookies.remove('token')
    currentUserSubject.next(null);

}